import { useEffect, useState } from "react";
import SurnameInput from "../../medicalDocument/form/patient/SurnameInput";
import { useApi } from "../../../../utils/hooks";
import usePatientSearchStrategy from "./hooks/usePatientSearchStrategy";
import _ from "lodash";

const PatientAutocomplete = ({ patientId, ...props }) => {
  const [patient, setPatient] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const api = useApi();
  const { strategyProps } = usePatientSearchStrategy();

  useEffect(() => {
    if (patientId && _.isEmpty(patient)) {
      api.patientsDetails(patientId)
        .tap(setPatient)
        .catch(console.error)
        .finally(() => setIsLoading(false));

      return;
    }
  }, [patientId]);

  const finalProps = _.assign(patientId && !strategyProps?.onAsyncSearch ? { loading: isLoading } : {}, strategyProps);

  return (
    <SurnameInput
      patient={patient}
      {...finalProps}
      {...props}
    />
  );
};

export default PatientAutocomplete;
